import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-surveys-icon',
  templateUrl: './surveys-icon.component.html',
  styleUrls: ['./surveys-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SurveysIconComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
